<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <table-tool-bar>
                <Button v-if="$can('add')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd"
                >创建规则</Button>
            </table-tool-bar>
            <Table
                ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight"
            >
                <!-- 操作列 -->
                <template v-slot:action="{ row }">
                    <Button
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickInfo(row)"
                    >详情</Button>
                    <PoptipButton v-if="$can('delete')"
                        text="删除"
                        transfer
                        type="default"
                        title="您确定删除这条记录吗？"
                        :ok="() => { rowConfirmDelete(row) }"
                    ></PoptipButton>
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager
                :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"
            ></table-pager>
            <!-- 弹出层 -->
            <smart-modal
                v-model="modal.showRule"
                :title="curId ? '规则编辑' : '规则登记'"
                :width="800"
                :height="330"
                :maskClosable="false"
                :buttons.sync="formBtns"
                @close-by-confirm="search"
            >
                <form-rule v-if="modal.showRule" :id="curId"></form-rule>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import FormRule from './form-rule'
import { projRulesList, projRulesDelete } from '@/api/rule-manage'

const PAGE_SIZE = 20

const fetchData = function() {
    return Promise.all([
        projRulesList({
            pageNo: 1,
            pageSize: PAGE_SIZE
        })
    ])
}

export default {
    name: 'ListRule',

    components: {
        FormRule
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE
            },
            page: {
                total: 0,
                list: []
            },
            dict: {},
            modal: {
                showRule: false
            },
            curId: '',
            formBtns: [],
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'projName',
                    title: '项目',
                    align: 'left',
                    minWidth: 200
                },
                {
                    key: 'reportedDays',
                    title: '推荐报备有效期',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'visitDays',
                    title: '到访确认有效期',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'remark',
                    title: '说明',
                    align: 'left',
                    minWidth: 200,
                    tooltip: true
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    slot: 'action'
                }
            ]
        }
    },

    watch: {},

    beforeRouteEnter(to, from, next) {
        fetchData().then(args => {
            next(vm => vm.fillData(args))
        })
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([projRulesList(this.filter)])
                .then(args => {
                    var [page] = args

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.page.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
        fillData(args) {
            var [page] = args

            this.setPageData(page.data)
        },
        onClickAdd() {
            this.curId = ''
            this.modal.showRule = true
        },
        rowClickInfo(row) {
            this.curId = row.id
            this.modal.showRule = true
        },
        rowConfirmDelete(row) {
            this.loading = true
            projRulesDelete(row.id)
                .then(el => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>